var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdentityComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.973 33.2275C104.709 33.2275 106.116 34.6346 106.116 36.3704V77.5943C106.116 83.5271 101.28 88.5102 95.2003 88.5102H16.3694C14.6337 88.5102 13.2266 87.1031 13.2266 85.3673C13.2266 83.6316 14.6337 82.2244 16.3694 82.2244H95.2003C97.7577 82.2244 99.8305 80.1062 99.8305 77.5943V36.3704C99.8305 34.6346 101.238 33.2275 102.973 33.2275Z",
    fill: "#D2E5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9548 83.9276C11.2526 83.9276 7.41406 80.089 7.41406 75.3868V45.9664V32.9558C7.41406 28.2536 11.2526 24.415 15.9548 24.415H23.7278H92.8969C97.5991 24.415 101.438 28.2536 101.438 32.9558V75.2908C101.438 79.9931 97.5991 83.8316 92.8969 83.8316H15.9548V83.9276Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.326 31.0278C101.326 27.4265 98.5791 24.564 95.1908 24.564H13.5974C10.2092 24.564 7.46191 27.5189 7.46191 31.0278C7.46191 31.0278 12.5901 38.5075 54.3484 38.5075C96.1066 38.5075 101.326 31.0278 101.326 31.0278Z",
    fill: "#EBF1F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.955 25.8286C12.0339 25.8286 8.82857 29.0339 8.82857 32.955V75.3861C8.82857 78.9102 11.4178 81.8562 14.7888 82.4165H92.8971C96.8182 82.4165 100.024 79.2112 100.024 75.2901V32.955C100.024 29.0339 96.8182 25.8286 92.8971 25.8286H15.955ZM17.3693 85.2451H92.8971C98.3804 85.2451 102.852 80.7734 102.852 75.2901V32.955C102.852 27.4717 98.3804 23 92.8971 23H15.955C10.4717 23 6 27.4717 6 32.955V75.3861C6 80.8694 10.4717 85.3411 15.955 85.3411H17.3693V85.2451Z",
    fill: "#3694E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6159 56.8068C31.8022 56.8068 34.3851 54.2023 34.3851 50.9894C34.3851 47.7765 31.8022 45.1719 28.6159 45.1719C25.4297 45.1719 22.8467 47.7765 22.8467 50.9894C22.8467 54.2023 25.4297 56.8068 28.6159 56.8068Z",
    fill: "#2DD68A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3223 68.6263C38.7802 68.6263 39.1465 68.2569 39.1465 67.7952C39.1465 63.0858 35.5751 59.2075 31.271 59.2075H26.0512C21.7472 59.2075 18.1758 63.0858 18.1758 67.7952C18.1758 68.2569 18.5421 68.6263 19 68.6263H38.3223Z",
    fill: "#2DD68A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3594 49.6964C48.3594 48.9175 48.9908 48.2861 49.7696 48.2861H86.4912C87.2701 48.2861 87.9015 48.9175 87.9015 49.6964C87.9015 50.4753 87.2701 51.1066 86.4912 51.1066H49.7696C48.9908 51.1066 48.3594 50.4753 48.3594 49.6964Z",
    fill: "#DEE9F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3594 58.2843C48.3594 57.5054 48.9908 56.874 49.7696 56.874H86.4912C87.2701 56.874 87.9015 57.5054 87.9015 58.2843C87.9015 59.0631 87.2701 59.6945 86.4912 59.6945H49.7696C48.9908 59.6945 48.3594 59.0631 48.3594 58.2843Z",
    fill: "#DEE9F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3594 66.7799C48.3594 66.001 48.9908 65.3696 49.7696 65.3696H72.114C72.8928 65.3696 73.5242 66.001 73.5242 66.7799C73.5242 67.5587 72.8928 68.1901 72.114 68.1901H49.7696C48.9908 68.1901 48.3594 67.5587 48.3594 66.7799Z",
    fill: "#DEE9F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 50C80.0593 50 72 41.9409 72 32.0004C72 22.0591 80.0593 14 90 14C99.9415 14 108 22.0591 108 32.0004C108 41.9409 99.9415 50 90 50Z",
    fill: "#00C66F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.74 26.7585C99.4257 27.6244 99.2796 28.8823 98.4136 29.568L86.7066 38.8383C85.8424 39.5226 84.5873 39.3786 83.9006 38.5163L80.4356 34.1654C79.7475 33.3014 79.8901 32.0431 80.7541 31.355C81.6182 30.6669 82.8764 30.8095 83.5646 31.6736L85.7871 34.4642L95.9304 26.4321C96.7964 25.7464 98.0542 25.8925 98.74 26.7585Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityComplete);
export default __webpack_public_path__ + "static/media/identity-complete.71fe5033a17f476a0408b66e2612b043.svg";
export { ForwardRef as ReactComponent };